import React, { useEffect, useState } from "react";
import { useAuthStore } from "../../../../store/store";
import { getUsername } from "helper/helper";

function NavAvatar() {
  const setInLogoutMode = useAuthStore((state) => state.setInLogoutMode);

  const [userInfo, setUserInfo] = useState({ userId: "", username: "" });
  const [usuario, setUsuario] = useState({});
  /*const [OTP, setOTP] = useState({
    isLoading: false,
    apiData: undefined,
    status: null,
    serverError: undefined,
  });*/
  const { username } = useAuthStore((state) => {
    console.log(state);
    return state.auth;
  });

  const fetchData = async () => {
    const decoded = await getUsername();

    setUserInfo({
      //  ...userInfo,
      userId: decoded.userId,
      username: decoded.username,
    });

    setUsuario({
      username: decoded.username,
      departamento: decoded.departamento,
    });
  };

  useEffect(() => {
    fetchData();

    console.log("---123");
    console.log(username);

    // Listening to selected changes, in this case when "paw" changes
    //https://zustand.docs.pmnd.rs/middlewares/subscribe-with-selector

    const unsubscribeCount = useAuthStore.subscribe(
      (state) => state.candy,
      (newCount, prevCount) => {
        console.log(`candy changed: ${newCount}`);
      },
    );

    return () => {
      unsubscribeCount(); // Unsubscribe on component unmount
    };
  }, []);

  // logout handler function
  function userLogout() {
    setInLogoutMode(true);
  }

  return (
    <li className="nav-item dropdown pe-3">
      <a
        href="#"
        alt=""
        className="nav-link nav-profile d-flex align-items-center pe-0"
        data-bs-toggle="dropdown"
      >
        <i className="bi bi-person-circle"></i>
        <span className="d-none d-md-block dropdown-toggle ps-2">
          {usuario.username}
        </span>
      </a>

      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
        <li className="dropdown-header">
          <h6>{usuario.nombre}</h6>
          <span>{usuario.departamento}</span>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>

        {/*    <li>
          <a
            className="dropdown-item d-flex align-items-center"
            href="users-profile.html"
          >
            <i className="bi bi-person"></i>
            <span>Mi Perfil</span>
          </a>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <a
            className="dropdown-item d-flex align-items-center"
            href="users-profile.html"
          >
            <i className="bi bi-gear"></i>
            <span>Configuración</span>
          </a>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <a
            className="dropdown-item d-flex align-items-center"
            href="pages-faq.html"
          >
            <i className="bi bi-question-circle"></i>
            <span>Ayuda</span>
          </a>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>*/}

        <li>
          <a
            className="dropdown-item d-flex align-items-center"
            onClick={userLogout}
          >
            <i className="bi bi-box-arrow-right"></i>
            <span>Cerrar sesión</span>
          </a>
        </li>
      </ul>
    </li>
  );
}

export default NavAvatar;
